import { ColorPicker, Grid, NativeSelect, Text, TextInput } from '@mantine/core';
import { useState } from 'react';

const TemplateFields = ({ disabled, handleChangeStyles, productBlockStyles, handleChangeColors, fieldConfigs }) => {
  // Create separate state variables for each color picker
  const [colorPickerStates, setColorPickerStates] = useState(
    fieldConfigs.reduce((acc, field) => {
      acc[field.stateKey] = false;
      return acc;
    }, {})
  );

  // Function to toggle the color picker state
  const toggleColorPicker = (fieldKey) => {
    setColorPickerStates((prevState) => ({
      ...prevState,
      [fieldKey]: !prevState[fieldKey],
    }));
  };

  return (
    <>
      {fieldConfigs.map((field) => (
        <Grid key={field.controlId}>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>
              {field.label}
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            {field.inputType === 'select' ? (
              <NativeSelect
                onChange={handleChangeStyles}
                id={field.controlId}
                name={field.name}
                value={productBlockStyles[field.stateKey]}
                disabled={disabled}
                data={field.options.map((option) => ({ value: option.value, label: option.label }))}
              />
            ) : field.inputType === 'color' ? (
              <>
                <span
                  style={{
                    width: 36,
                    height: 36,
                    display: 'inline-block',
                    marginRight: 10,
                    borderRadius: 8,
                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                    background: productBlockStyles[field.stateKey],
                    cursor: disabled ? 'default' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (!disabled) {
                      toggleColorPicker(field.stateKey);
                    }
                  }}
                >
                  &nbsp;
                </span>
                {!disabled && colorPickerStates[field.stateKey] && (
                  <ColorPicker
                    id={field.controlId}
                    name={field.name}
                    value={productBlockStyles[field.stateKey] || ''}
                    onChange={(color) => handleChangeColors(field.stateKey, color)}
                  />
                )}
              </>
            ) : (
              <TextInput
                type={field.inputType}
                id={field.controlId}
                name={field.name}
                value={productBlockStyles[field.stateKey] || ''}
                disabled={disabled}
                onChange={handleChangeStyles}
              />
            )}
          </Grid.Col>
        </Grid>
      ))}
    </>
  );
};

export default TemplateFields;
